import { render, staticRenderFns } from "./ReceiptRequest.vue?vue&type=template&id=12ddd39a&scoped=true&"
import script from "./ReceiptRequest.vue?vue&type=script&lang=js&"
export * from "./ReceiptRequest.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptRequest.vue?vue&type=style&index=0&id=12ddd39a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ddd39a",
  null
  
)

export default component.exports